// US-09: тонкая обёртка над Nominatim для bulk-import диалога.
// Throttle на клиенте — 1 req/sec соответствует Nominatim usage policy.
// https://operations.osmfoundation.org/policies/nominatim/

const NOMINATIM_URL = 'https://nominatim.openstreetmap.org/search';
const RATE_LIMIT_MS = 1100; // 1.1 sec — небольшой запас сверх 1/sec

export interface GeocodeResult {
  lat: number;
  lon: number;
  displayName: string;
}

let lastRequestAt = 0;

async function throttledSleep(): Promise<void> {
  const now = Date.now();
  const elapsed = now - lastRequestAt;
  const wait = Math.max(0, RATE_LIMIT_MS - elapsed);
  if (wait > 0) await new Promise((r) => setTimeout(r, wait));
  lastRequestAt = Date.now();
}

/**
 * Один geocode-запрос с soft-bias на Италию. Возвращает null если
 * адрес не найден или ошибка сети — пользователь увидит это в превью.
 */
export async function geocode(query: string): Promise<GeocodeResult | null> {
  await throttledSleep();
  const params = new URLSearchParams({
    q: query,
    format: 'json',
    limit: '1',
    countrycodes: 'it',
    'accept-language': 'en,it',
  });
  try {
    const res = await fetch(`${NOMINATIM_URL}?${params.toString()}`, {
      headers: {
        // Nominatim TOS требует identifying header. Без него политика может
        // вернуть 403. Email/website можно подменить на свой prod-домен.
        'User-Agent': 'lodestar/1.0 (https://lodestar.place)',
      },
    });
    if (!res.ok) return null;
    const data = (await res.json()) as Array<{ lat: string; lon: string; display_name: string }>;
    if (!data.length) return null;
    const top = data[0];
    return {
      lat: parseFloat(top.lat),
      lon: parseFloat(top.lon),
      displayName: top.display_name,
    };
  } catch {
    return null;
  }
}
